module.exports = __webpack_public_path__ + "media/img/apple-icon-76x76-7006620226e51ee5dc27907c3c7ef6e0.png";